module.exports = __webpack_public_path__ + "static/media/4ODA16.73d1c9d0.jpg";